<template>
  <div :class="classObj" class="app-wrapper">
    <div
      v-if="device === 'mobile' && sidebar.opened && tempCondition"
      class="drawer-bg"
      @click="handleClickOutside"
    />
    <sidebar class="sidebar-container" v-if="tempCondition" />
    <div
      class="main-container"
      :class="{
        'main-no-margin': noMarginCondition
      }"
    >
      <navbar v-if="tempCondition" />
      <tags-view v-if="tempCondition" />
      <el-scrollbar
        :native="false"
        :wrap-class="tempCondition ? 'main-scrollbar' : 'temp-scrollbar'"
      >
        <app-main />
      </el-scrollbar>
      <notification />
      <el-footer v-if="showFooter" class="footer" height="3rem">
        <a target="_blank" href="http://www.hemiao100.com">
          Copyright©{{ thisYear }}禾苗(武汉)信息技术有限公司.ALL rights
          reserved.
        </a>
        <a
          target="_blank"
          style="margin-left:10px"
          href="https://beian.miit.gov.cn"
          >鄂ICP备15014881号</a
        >
      </el-footer>
    </div>
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain, Notification } from "./components";
import TagsView from "./components/TagsView";
import ResizeMixin from "./mixin/ResizeHandler";

export default {
  name: "Layout",
  components: {
    Navbar,
    Sidebar,
    AppMain,
    TagsView,
    Notification
  },
  watch: {
    $route(val) {
      this.routeName = val.name;
    }
  },
  data() {
    return {
      noMarginRoute: [
        "FrisoTemp",
        "Temp",
        "ServeTemp",
        "UserCenterTemp",
        "GuideTemp",
        "AddPromotionalBeltTemp",
        "StoreDecorationTemp",
        "PlusPageTemp",
        "ReportTemp",
        "AddVisualReportConfig",
        "DrawBigger"
      ], // 不显示tab和菜单和页脚的页面
      onlyNofooterRoute: [
        "SalesVolumeDetails",
        "WithdrawDetails",
        "GuiderApplyDetails",
      ], // 只不显示页脚的页面
      routeName: "",
      thisYear: new Date().getFullYear()
    };
  },
  mixins: [ResizeMixin],
  created() {
    this.routeName = this.$route.name;
  },
  computed: {
    tempCondition() {
      const result =
        this.noMarginRoute.findIndex(v => v === this.routeName) === -1;
      return result;
      // return (
      //   this.routeName !== "Temp" &&
      //   this.routeName !== "UserCenterTemp" &&
      //   this.routeName !== "GuideTemp" &&
      //   this.routeName !== "AddPromotionalBeltTemp" &&
      //   this.routeName !== "StoreDecorationTemp" &&
      //   this.routeName !== "PlusPageTemp"
      // );
    },
    noMarginCondition() {
      const result =
        this.noMarginRoute.findIndex(v => v === this.routeName) > -1;
      return result;
      // return (
      //   this.routeName === "Temp" ||
      //   this.routeName === "UserCenterTemp" ||
      //   this.routeName === "GuideTemp" ||
      //   this.routeName === "AddPromotionalBeltTemp" ||
      //   this.routeName === "StoreDecorationTemp" ||
      //   this.routeName === "PlusPageTemp"
      // );
    },
    showFooter() {
      const list = this.noMarginRoute.concat(this.noFooterList);
      const result = list.findIndex(v => v === this.routeName) === -1;
      return result;
      // return (
      //   this.routeName !== "SalesVolumeDetails" &&
      //   this.routeName !== "WithdrawDetails" &&
      //   this.routeName !== "GuiderApplyDetails" &&
      //   this.routeName !== "Temp" &&
      //   this.routeName !== "UserCenterTemp" &&
      //   this.routeName !== "GuideTemp" &&
      //   this.routeName !== "AddPromotionalBeltTemp" &&
      //   this.routeName !== "StoreDecorationTemp" &&
      //   this.routeName !== "PlusPageTemp"
      // );
    },
    sidebar() {
      return this.$store.state.app.sidebar;
    },
    device() {
      return this.$store.state.app.device;
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === "mobile"
      };
    }
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch("CloseSideBar", { withoutAnimation: false });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/styles/mixin.scss";
.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;
  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}
.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}
.main-container.main-no-margin {
  margin-left: 0 !important;
  .main-router-wrapper {
    padding: 0;
  }
}

.footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px;
  background: #fff;
  color: #97a8be;
  font-size: 14px;
  border: 1px solid #ebeef5;
  z-index: 1;
}
</style>
